import { Enum } from '@/helpers/enum'
import { API } from '@/models/core'

export const KabaddiPlayerRole = new Enum({
  Defender: 'defender', 
  DefenderLeftCover: 'defender_left_cover',
  DefenderRightCover: 'defender_right_cover',
  DefenderLeftCorner: 'defender_left_corner',
  DefenderRightCorner: 'defender_right_corner',
  DefenderRightLeftCorner:'defender_right_left_corner',
  DefenderRightLeftCover:'defender_right_left_cover',
  AllRounders: 'all_rounder',
  Raiders: 'raider'
})

export const KabaddiPlayerRoleOrder = [
  { keys: [KabaddiPlayerRole.Raiders.key], name: 'Raiders' },
  { keys: [KabaddiPlayerRole.DefenderLeftCover.key], name: 'Defender Left Cover' },
  { keys: [KabaddiPlayerRole.DefenderRightCover.key], name: 'Defender Right Cover' },
  { keys: [KabaddiPlayerRole.DefenderLeftCorner.key], name: 'Defender Left Corner' },
  { keys: [KabaddiPlayerRole.DefenderRightCorner.key], name: 'Defender Right Corner' },
  { keys: [KabaddiPlayerRole.DefenderRightLeftCorner.key], name: 'Defender Right left Corner' },
  { keys: [KabaddiPlayerRole.DefenderRightLeftCover.key], name: 'Defender Right left cover' },
  { keys: [KabaddiPlayerRole.AllRounders.key], name: 'All Rounders' },
  { keys: [KabaddiPlayerRole.Defender.key], name: 'Defender' },
  { keys: null, name: 'Others' }
]

export class KabaddiPlayer {
  get groupingRole () {
    if (this.isValidSeasonRole) {
      return KabaddiPlayerRole.praseSafe(this.role)
    }

    return KabaddiPlayerRole.Unknown
  }

  get parsedRole () {
    let possibleRole = null

    if (this.role) {
       if (this.role.isDefender || this.role.isDefenderLeftCover || this.role.isDefenderRightCover || this.role.isDefenderLeftCorner || this.role.isDefenderRightCorner || this.role.isDefenderRightLeftCorner || this.role.isDefenderRightLeftCover) {
        possibleRole = KabaddiPlayerRole.Defender
      }

      if (this.role.isAllRounders) {
        possibleRole = KabaddiPlayerRole.AllRounders
      }

      if (this.role.isRaiders) {
        possibleRole = KabaddiPlayerRole.Raiders
      }
    }
    return possibleRole
  }

  get isSeasonalRoleDifferent () {
    const possibleRole = KabaddiPlayerRole.praseSafe(this.role)
    return possibleRole !== this.role
  }

  get isValidSeasonRole () {
    const possibleRole = KabaddiPlayerRole.praseSafe(this.role)
    return possibleRole != null
  }

  static createFromJson (key, raw) {
    let player = new KabaddiPlayer()
    player = Object.assign(player, raw)
    player.key = key
    player.role = KabaddiPlayerRole.parse(player.role)
    
    return player
  }
}

KabaddiPlayer.State = {
  selected: null
}
